import React from "react";
import { PageHeader } from "antd";
import JcpEnrollmentEntry from "../../components/enrollment/jcp/JcpEnrollmentEntry";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ScheduleChangeComp from "../../components/enrollment/ScheduleChangeComp";

const ScheduleChange = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Schedule Change"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <ScheduleChangeComp />
      </div>
    </div>
  );
};

export default ScheduleChange;
